"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
function hookFactory() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (hook) {
        return typeof hook === 'function' ? hook.apply(hook, args) : null;
    };
}
function formatCallbackArgs(data) {
    var resObj = typeof data === 'string' && util_1.jsonREG.test(data)
        ? JSON.parse(data)
        : (typeof data === 'object' && data !== null
            ? data
            : { result: data });
    var errno = resObj.errno, errmsg = resObj.errmsg, errorCode = resObj.errorCode, errorMsg = resObj.errorMsg, code = resObj.code, message = resObj.message;
    errno = +(errno || errorCode || code || 0);
    errmsg = errmsg || errorMsg || message || '';
    var err = { errno: errno, errmsg: errmsg };
    var res = resObj.result !== undefined ? resObj.result : resObj;
    return {
        err: errno ? err : null,
        res: res,
        rawData: data
    };
}
exports.formatCallbackArgs = formatCallbackArgs;
function default_1(app, config) {
    var bridgeArgs = [];
    var bridgeMethods = [];
    var bridgeRes = {};
    var count = 0;
    return function bridgeMethodArgsFactory(method, params, callback, module) {
        var middlewareConfig = config[method] || {};
        var tmpMethod;
        var tmpParams;
        var tmpCallback;
        var tmpCallbackCached;
        var tmpModule;
        var originalCallback = function (err, res) {
            callback(err, res);
            bridgeArgs = [];
            bridgeMethods = [];
            bridgeRes = {};
        };
        var aggregationCallback = function (err, res) {
            if (!err && res) {
                bridgeRes = __assign({}, bridgeRes, res);
                count++;
                if (count >= bridgeArgs.length) {
                    originalCallback(err, bridgeRes);
                }
            }
            else {
                bridgeRes = __assign({}, bridgeRes, res);
                originalCallback(err, bridgeRes);
            }
        };
        var hook = hookFactory(app, method, params, aggregationCallback);
        tmpMethod = hook(middlewareConfig.method) || method;
        tmpParams = hook(middlewareConfig.param) || params;
        tmpCallback = hook(middlewareConfig.callback) || function (_a) {
            var err = _a.err, res = _a.res;
            aggregationCallback(err, res);
        };
        tmpCallbackCached = !!hook(middlewareConfig.shouldCallbackCached);
        tmpModule = module || middlewareConfig.module || '';
        if (Array.isArray(tmpMethod)) {
            var parentMethod_1;
            tmpMethod.forEach(function (childMethod) {
                if (!util_1.arrayIndexOf(bridgeMethods, childMethod)) {
                    if (childMethod !== method) {
                        bridgeMethodArgsFactory(childMethod, params, callback, module);
                    }
                    else {
                        parentMethod_1 = childMethod;
                    }
                }
            });
            tmpMethod = parentMethod_1;
        }
        var tmpFormatCallback = function (result) { return tmpCallback(formatCallbackArgs(result)); };
        tmpFormatCallback._isCached = tmpCallbackCached;
        if (tmpMethod) {
            bridgeArgs.push([
                tmpMethod,
                tmpParams,
                tmpFormatCallback,
                tmpModule
            ]);
            bridgeMethods.push(tmpMethod);
        }
        return bridgeArgs;
    };
}
exports.default = default_1;
